import { Button, Link } from 'zudoku/components'
import { Badge } from 'zudoku/ui/Badge';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "zudoku/ui/Card";
import { ArrowRight } from 'zudoku/icons';
import { products } from '../../data/products';

export const ProductCards = ({ className }) => (
    <section {...{ className }}>
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {products.map((product) => (
              <div key={product.id} className="group" >
                <Card className={`p-2 h-full border-2 flex flex-col transition-all duration-300 group-hover:shadow-lg ${
                    product.status === 'coming-soon' && 'opacity-75'
                  }`}>
                  <CardHeader>
                    <div className="flex items-center justify-between mb-4">
                      <CardTitle className="text-2xl font-bold">
                        {product.name}
                      </CardTitle>
                      {product.status === 'coming-soon' && (
                        <Badge variant="secondary">Coming Soon</Badge>
                      )}
                    </div>
                    <CardDescription className="text-md leading-relaxed">{product.tagline}</CardDescription>
                  </CardHeader>
                  <CardContent className="text-sm flex-1">
                    {product.description}
                  </CardContent>
                  <CardFooter>
                    <Button
                      variant={product.status === 'active' ? 'default' : 'secondary'}
                      className="w-full"
                      asChild
                    >
                      <Link to={`/products/${product.id}`}>
                        {product.buttonText}
                        <ArrowRight className="ml-2 h-4 w-4" />
                      </Link>
                    </Button>
                  </CardFooter>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </section>
)